"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeBrandApi = _interopRequireWildcard(require("@/api/storeBrandApi.js"));
var _validate = require("@/utils/validate");
var _systemSetting = require("@/api/systemSetting.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {
    // 默认商品类型，1-实物商品，2-卡劵商品
    defaultProductType: {
      type: Number,
      default: null
    },
    // 默认状态，1-启用，0-禁用
    defaultStatus: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      isSupplier: false,
      // 判断当前用户是否是供应商
      userType: null,
      // 用户类型
      pram: {
        id: null,
        productType: null,
        brandName: '',
        status: null,
        brandLogo: '',
        brandRemark: ''
      },
      brandOption: []
    };
  },
  mounted: function mounted() {
    this.checkSupplierRole();
    // 获取用户类型
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      this.userType = JavaInfo.type;
    } catch (e) {
      this.userType = null;
    }
  },
  methods: {
    openInit: function openInit(id) {
      var _this = this;
      if (!id) {
        // 新增时，设置默认值
        this.pram = {
          id: null,
          productType: this.defaultProductType !== null ? this.defaultProductType : null,
          brandName: '',
          status: this.defaultStatus !== null ? this.defaultStatus : null,
          brandLogo: '',
          brandRemark: ''
        };
        this.visible = true;
        return;
      }
      ;
      storeBrandApi.getBrandInfo(id).then(function (res) {
        _this.pram = _objectSpread({}, res);
        // 如果是供应商，清空不需要的字段
        _this.clearSupplierFields();
        _this.visible = true;
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this2 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        // 如果是供应商，在提交前清空不需要的字段
        _this2.clearSupplierFields();
        _this2.loading = true;
        storeBrandApi[_this2.pram.id ? 'UpdateArticle' : 'AddArticle'](_this2.pram).then(function (data) {
          _this2.$message.success('操作成功');
          _this2.loading = false;
          _this2.visible = false;
          _this2.$emit('doRefresh');
        }).catch(function () {
          _this2.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    //上传图片
    modalPicTap: function modalPicTap(tit, dataIndex) {
      var _this3 = this;
      this.$modalUpload(function (img) {
        _this3.$set(_this3.pram, dataIndex, img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(dataIndex) {
      this.$set(this.pram, dataIndex, '');
    },
    // 检查当前用户是否为供应商
    checkSupplierRole: function checkSupplierRole() {
      try {
        var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        if (JavaInfo && JavaInfo.supplierId && JavaInfo.supplierId !== 0) {
          this.isSupplier = true;
          // 如果是供应商，清空logo和简介字段
          this.clearSupplierFields();
        } else {
          this.isSupplier = false;
        }
      } catch (e) {
        this.isSupplier = false;
      }
    },
    // 清空供应商不需要的字段
    clearSupplierFields: function clearSupplierFields() {
      if (this.isSupplier) {
        this.pram.brandLogo = '';
        this.pram.brandRemark = '';
      }
    },
    // 本地上传前的校验
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB！');
        return false;
      }
      return true;
    },
    // 处理本地上传
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(options) {
        var file, formData, params, loading, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = options.file;
              formData = new FormData();
              formData.append('multipart', file);
              params = {
                model: 'product',
                pid: 1
              };
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.p = 1;
              _context.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, params);
            case 2:
              res = _context.v;
              loading.close();
              if (res && res.url) {
                this.pram.brandLogo = res.url;
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              loading.close();
              this.$message.error('上传失败：' + (_t.message || '请重试'));
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }()
  }
};